<template>
    <div class="game-data" v-if="game.homeTeam || sportType === '冰球'">
      <div v-if="sportType === '篮球'" class="basketball">
        <div class="box1 flex-conter">
          <div class="title">
            <div class="item">球队</div>
            <div class="name overflow-text">{{ game.homeTeam.name }}</div>
            <div class="name1 overflow-text">{{ game.awayTeam.name }}</div>
          </div>
          <div style="overflow-x: auto;" scroll-x class="scroll scroll-my">
            <div class="content">
              <div class="title flex-conter" :style="{width:length * 125 + 'px'}">
                <div class="item" v-for="item in stages" :key="item.id">第{{item.seq}}节</div>
                <div class="item">总分</div>
              </div>
              <div class="scroll-box" :style="{width:length * 125 + 'px'}">
                <div class="t1 flex-conter">
                  <div v-for="item in stages" :key="item.id">{{ item.homeScore }}</div>
                  <div>{{ game.homeScore }}</div>
                </div>
                <div class="t1 flex-conter">
                  <div v-for="item in stages" :key="item.id">{{ item.awayScore }}</div>
                  <div>{{ game.awayScore }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-box">全场最佳</div>
        <div class="box4">
          <div scroll-x style="width: 100%;overflow-x: auto;" class="scroll-my">
            <div class="scroll" :style="{width: 222 * topList + 'px'}">
              <div class="card" v-for="item in topPlayers" :key="item.player.id">
                <div class="t1">
                  <i></i>
                  <span></span>
                  <p>{{ item.type }}</p>
                </div>
                <p class="t2">{{ item.top }}</p>
                <div class="t3 flex-conter" style="justify-content: flex-start;">
                  <img src="https://www.snsports.cn/webapp-stage/images/Mensingles.png" />
                  <div>
                    <p>{{ item.player.trueName }}</p>
                    <span>{{ item.player.twoPointTotal}}/{{ item.player.teamName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title-box red">队员数据 - {{ game.homeTeam.name }}</div>
        <div class="box3">
          <div class="title" v-if="teams.length !== 0">
            <div class="item">号码/球员</div>
            <div class="name" v-for="item in teams[0].players" :key="item.id">{{ item.number }}/{{ item.trueName.substr(0, 4) }}</div>
          </div>
          <div scroll-x class="scroll scroll-my" style="overflow-x: auto;">
            <div class="content">
              <div class="item" v-for="item in titleList" :key="item">{{ item }}</div>
            </div>
            <div class="content" v-for="item in teams[0].players" :key="item.id">
              <div class="score">{{ item.score }}</div>
              <div class="score">{{ item.assistCount }}</div>
              <div class="score">{{ item.frontReboundCount }}</div>
              <div class="score">{{ item.blockCount }}</div>
              <div class="score">{{ item.stealCount }}</div>
              <div class="score">{{ item.twoPointCount }}</div>
              <div class="score">{{ item.threePointCount }}</div>
              <div class="score">{{ item.freeThrowCount }}</div>
              <div class="score">{{ item.turnoverCount }}</div>
              <div class="score">{{ item.foulCount }}</div>
            </div>
          </div>
        </div>
        <div class="title-box lan">队员数据 - {{ game.awayTeam.name }}</div>
        <div class="box3">
          <div class="title" v-if="teams.length !== 0">
            <div class="item">号码/球员</div>
            <div class="name" v-for="item in teams[1].players" :key="item.id">{{ item.number }}/{{ item.trueName.substr(0, 4) }}</div>
          </div>
          <div style="overflow-x: auto;" scroll-x class="scroll scroll-my">
            <div class="content">
              <div class="item" v-for="item in titleList" :key="item">{{ item }}</div>
            </div>
            <div class="content" v-for="item in teams[1].players" :key="item.id">
              <div class="score">{{ item.score }}</div>
              <div class="score">{{ item.assistCount }}</div>
              <div class="score">{{ item.frontReboundCount }}</div>
              <div class="score">{{ item.blockCount }}</div>
              <div class="score">{{ item.stealCount }}</div>
              <div class="score">{{ item.twoPointCount }}</div>
              <div class="score">{{ item.threePointCount }}</div>
              <div class="score">{{ item.freeThrowCount }}</div>
              <div class="score">{{ item.turnoverCount }}</div>
              <div class="score">{{ item.foulCount }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="sportType === '足球'" class="football">
        <div class="title flex-conter">
          <div class="flex-conter t1" style="justify-content: flex-end;">
            <p class="overflow-text">{{ game.homeTeam.name }}</p>
            <img :src="game.homeTeam.badge" style="margin-left: 12px;" />
          </div>
          <div style="width: 100px;text-align: center;">
            {{ game.homeScore === -1 ? '': game.homeScore }} - {{ game.awayScore === -1 ? '': game.awayScore }}
          </div>
          <div class="flex-conter t1" style="justify-content: flex-start;">
            <img :src="game.awayTeam.badge" style="margin-right: 12px;" />
            <p class="overflow-text">{{ game.awayTeam.name }}</p>
          </div>
        </div>
        <div class="title-box">球员统计</div>
        <div class="gameEvent">
          <div class="card left">
            <div class="item" v-for="item in gameStats.homeTeamStats" :key="item.id">
              <p>{{ item.playerInfo }}</p>
              <div class="flex-conter icon" style="justify-content: flex-start;">
                <div class="flex-conter" v-for="(it,i) in item.details" :key="i"><img :src="it.icon" /> x{{ it.quantity }}</div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="item" v-for="item in gameStats.awayTeamStats" :key="item.id">
              <p style="text-align: right;">{{ item.playerInfo }}</p>
              <div class="flex-conter icon" style="justify-content: flex-end;">
                <div class="flex-conter" style="justify-content: flex-end;" v-for="(it,i) in item.details" :key="i"><img :src="it.icon" /> x{{ it.quantity }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ts">
          <p>球员统计模式</p>
          <p>录入球员的进球/助攻/红黄牌数量</p>
        </div>
      </div>
      <div v-else-if="sportType === '冰球'" class="ice-hockey">
        <div v-if="beibingGameId">
          <div class="table" v-if="gameResult.length > 0">
            <div class="left">
              <div class="link">
                <div class="item team-name title">球队</div>
                <div class="item title">总分</div>
              </div>
              <div class="link home">
                <div class="item team-name overflow-text">{{ gameResult[0].name }} <span v-if="qiquan === 1 && (gameResult[0].total <= gameResult[1].total)"> (弃权)</span></div>
                <div class="item" style="font-weight: bold;">{{ gameResult[0].total }}</div>
              </div>
              <div class="link away">
                <div class="item team-name overflow-text">{{ gameResult[1].name }} <span v-if="qiquan === 1 && (gameResult[1].total <= gameResult[0].total)"> (弃权)</span></div>
                <div class="item" style="font-weight: bold;">{{ gameResult[1].total }}</div>
              </div>
            </div>
            <div class="right">
              <div class="link">
                <div class="item title" v-for="item in titleList2" :key="item.value">{{ item.title }}</div>
              </div>
              <div class="link" :class="index === 0 ? 'home':'away'" v-for="(game,index) in gameResult" :key="index">
                <div class="item" v-for="item in titleList2" :key="item.value">{{ game[item.value] }}</div>
              </div>
            </div>
          </div>
          <div class="mvp" v-if="homePlayerMvp.id || awayPlayerMvp.id">
            <div class="title">全场最佳</div>
            <div class="card home" v-if="homePlayerMvp.id">
              <img :src="homePlayerMvp.profile" />
              <div class="info">
                <div class="name">{{ homePlayerMvp.trueName }}</div>
                <div class="text">{{ homePlayerMvp.jerseyNo + '号' }} <span style="margin-left: 12rpx;">{{ homePlayerMvp.position }}</span></div>
                <div class="position"><span>射中：{{ homePlayerMvp.goalCount }}</span> <span style="margin-left: 12rpx;">助攻：{{ homePlayerMvp.assist1Count + homePlayerMvp.assist2Count }}</span></div>
              </div>
              <div class="btn overflow-text">{{ homePlayerMvp.teamName }}</div>
            </div>
            <div class="card away" v-if="awayPlayerMvp.id">
              <img :src="awayPlayerMvp.profile" />
              <div class="info">
                <div class="name">{{ awayPlayerMvp.trueName }}</div>
                <div class="text">{{ awayPlayerMvp.jerseyNo + '号' }} <span style="margin-left: 12rpx;">{{ awayPlayerMvp.position }}</span></div>
                <div class="position"><span>射中：{{ awayPlayerMvp.goalCount }}</span> <span style="margin-left: 12rpx;">助攻：{{ awayPlayerMvp.assist1Count + awayPlayerMvp.assist2Count }}</span></div>
              </div>
              <div class="btn overflow-text">{{ awayPlayerMvp.teamName }}</div>
            </div>
          </div>
          <div class="players">
            <div class="title">出场名单</div>
            <div class="tabs">
              <div class="tab home" :class="index === 0 ? 'home-active' : ''" @click="index = 0">{{ homePlayerMvp.teamName }}</div>
              <div class="tab away" :class="index === 1 ? 'away-active' : ''" @click="index = 1">{{ awayPlayerMvp.teamName }}</div>
            </div>
            <div class="players-list">
              <div class="player-item label">
                <div class="info" style="padding-left: 8rpx;">球员</div>
                <div class="data">射中</div>
                <div class="data">一助</div>
                <div class="data">二助</div>
              </div>
              <div v-if="index === 0">
                <div v-for="item in homePlayers" :key="item.id" class="player-item">
                  <img :src="item.profile" />
                  <div class="info">
                    <div class="name">{{ item.trueName }}</div>
                    <div class="text">{{ item.jerseyNo + '号' }} <span style="margin-left: 12rpx;">{{ item.position }}</span></div>
                  </div>
                  <div class="data">{{ item.goalCount }}</div>
                  <div class="data">{{ item.assist1Count }}</div>
                  <div class="data">{{ item.assist2Count }}</div>
                </div>
              </div>
              <div v-else>
                <div v-for="item in awayPlayers" :key="item.id" class="player-item">
                  <img :src="item.profile" />
                  <div class="info">
                    <div class="name">{{ item.trueName }}</div>
                    <div class="text">{{ item.jerseyNo + '号' }} <span style="margin-left: 12rpx;">{{ item.position }}</span></div>
                  </div>
                  <div class="data">{{ item.goalCount }}</div>
                  <div class="data">{{ item.assist1Count }}</div>
                  <div class="data">{{ item.assist2Count }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="kong">
          <img src="https://images.snsports.cn/bsn_kong.png" />
          <p>暂无数据</p>
        </div>
      </div>
    </div>
</template>

<script>
import { GetBMGameBktData, GetBMGameDetail, getGameScore } from '@/api/match'
import { QNImageUtil } from '@/utils'

export default {
  props: {
    sportType: {
      type: String,
      default: ''
    },
    gameId: {
      type: Number,
      default: 0
    },
    beibingGameId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    console.log(this.sportType,'this.sportType');
    
     if (this.sportType === '冰球') { 
      this.getGameScore()
    } else {
      this.GetBMGameBktData()
      this.GetBMGameDetail()
    }
  },
  data() {
    return {
      teams: [],
      stages: [],
      game: {},
      length: 0,
      titleList: ['得分', '助攻', '篮板', '盖帽', '抢断', '两分', '三分', '罚球', '失误', '犯规'],
      gameStats: [],
      topPlayers: [],
      topList: [],
      qiquan: 0,
      homePlayers: [],
      awayPlayers: [],
      homePlayerMvp: {},
      awayPlayerMvp: {},
      gameResult: [],
      titleList2: [
        { title: '第1局', value: 'first'},
        { title: '第2局', value: 'second'},
        { title: '第3局', value: 'third'},
        { title: '加时', value: 'four'},
        { title: '射门', value: 'five'},
      ],
      index: 0
    }
  },
  methods: {
    getGameScore() {
      if(!this.beibingGameId) return
      getGameScore({id: this.beibingGameId}).then(res => {
        const { data } = res
        const gameScore = data.game
        this.qiquan = gameScore.qiquan
        const stages = data.stages
        this.gameResult = [
          { name: gameScore.homeTeam.name, first: stages.home1, second: stages.home2,
            third: stages.home3, four: stages.home4, five: stages.home5, total: stages.home },
          { name: gameScore.awayTeam.name, first: stages.away1, second: stages.away2,
            third: stages.away3, four: stages.away4, five: stages.away5, total: stages.away }
        ]
        this.homePlayers = gameScore.homeTeam.players.map(item => {
          item.profile = 'https://image.bjh.snsports.cn/' + item.profile + '?imageView2/1/w/120/h/120'
          return item
        })
        this.homePlayerMvp =  this.homePlayers.find(item => item.mvp === 1) || {}
        this.homePlayerMvp.teamName = gameScore.homeTeam.name

        this.awayPlayers = gameScore.awayTeam.players.map(item => {
          item.profile = 'https://image.bjh.snsports.cn/' + item.profile + '?imageView2/1/w/120/h/120'
          return item
        })
        this.awayPlayerMvp =  this.awayPlayers.find(item => item.mvp === 1) || {}
        this.awayPlayerMvp.teamName = gameScore.awayTeam.name
      })
    },
    GetBMGameBktData() {
      GetBMGameBktData({ gameId: this.gameId }).then(res => {
        const { data } = res
        this.teams = data.teams
        this.stages = data.stages
        this.length = data.stages.length + 1
        data.game.awayTeam.badge = QNImageUtil.imageView(data.game.awayTeam.badge, 200, 200)
        data.game.homeTeam.badge = QNImageUtil.imageView(data.game.homeTeam.badge, 200, 200)
        this.game = data.game
        this.topPlayers = data.topPlayers
        this.topList = data.topPlayers.length
        console.log(data.game,'game',this.sportType)
      })
    },
    GetBMGameDetail() {
      GetBMGameDetail({ gameId: this.gameId, eventMode: 1 }).then(res => {
        const { data } = res
        this.gameStats = this.buildGameStats(data.game)
      })
    },
    buildGameStats(game) {
      var supportedEventType = ['goal', 'penalty', 'assist', 'red', 'yellow']
      var gameStats = { homeTeamStats: [], awayTeamStats: [] }
      var processedGameEvents = []// 这个数组存放将助攻事件分离出来的事件列表
      game.gameEvent.forEach(function(event) {
        processedGameEvents.push(event)
        if (event.type === 'goal' && (event.otherPlayerId || event.otherPlayerId.length > 0)) { // 基于有助攻的进球事件添加一个助攻事件
          var newEvent = JSON.parse(JSON.stringify(event))
          newEvent.type = 'assist'
          newEvent.teamId = event.teamId
          newEvent.playerId = event.otherPlayerId
          newEvent.userId = event.otherUserId
          newEvent.userName = event.otherName
          newEvent.userNumber = event.otherNumber
          processedGameEvents.push(newEvent)
        }
      })
      processedGameEvents.forEach(function(event) {
        if (supportedEventType.indexOf(event.type) >= 0) {
          var list = (event.teamId === game.homeTeamId ? gameStats.homeTeamStats : gameStats.awayTeamStats)
          if (game.sportType === '分组对抗') {
            list = (event.group === 0 ? gameStats.homeTeamStats : gameStats.awayTeamStats)
          }
          if (event.type === 'assist') {
            event.userName = event.otherName
            event.userNumber = event.otherNumber
          }
          var userNumber = event.userNumber ? '[' + event.userNumber + ']' : ''
          var playerInfo = event.userName + userNumber
          var existedPlayerStats = list.find(function(stats) {
            return stats.playerInfo === playerInfo
          })
          if (event.type === 'penalty') { // 将点球也统计为进球
            event.type = 'goal'
          }
          var icon = `http://images.snsports.cn/game_icon_${event.type}.png`
          var statsDetail = { type: event.type, icon: icon, quantity: 1 }
          if (existedPlayerStats) {
            var details = existedPlayerStats.details
            var sameTypeItem = details.find(function(item) {
              return item.type === event.type
            })
            if (sameTypeItem) {
              sameTypeItem.quantity++
            } else {
              details.push(statsDetail)
            }
          } else {
            list.push({ teamId: event.teamId, playerId: event.playerId, playerInfo: playerInfo, details: [statsDetail] })
          }
        }
      })
      return gameStats
    }
  }
}
</script>

<style scoped lang="scss">
p{
  padding: 0;
  margin: 0;
}
.scroll-my{
  &::-webkit-scrollbar{
    display: none;
  }
}
.game-data{
  border-top: 1px solid rgb(249, 249, 249);
  padding-bottom: 5px;
  .basketball{
    .box1{
      background-color: #fff;
      .title{
        width: 125px;
        text-align: center;
        font-size: 13px;
        box-shadow: 6px 2px 6px 0px rgba(0,0,0,.06);
        .item{
          padding: 7px 0;
          color: #999;
        }
        .name,.name1{
          position: relative;
          height: 50px;
          line-height: 50px;
          // box-shadow: 6px 2px 6px 0px rgba(0,0,0,.06);
          &::before{
            content: '';
            width: 5px;
            position: absolute;
            height: 50px;
            left: 0;
            background-color: #FF726B;
          }
        }
        .name1{
          &::before{
            background-color: #37B8FF;
          }
        }
      }
      .scroll{
        width: 250px;
        .content{
          .title{
            box-shadow: none;
            width: 500px;
            .item{
              width: 125px !important;
              box-shadow:none;
            }
          }
        }
        .scroll-box{
          width: 500px;
          height: 100px;
          .t1{
            height: 50px;
            div{
              text-align: center;
              width: 125px;
            }
          }
        }
      }
    }
    .title-box{
      font-size: 17px;
      padding: 8px 16px;
      background-color: #FDFCFE;
      font-weight: 300;
    }
    .box2{
      margin-top: 1px;
      background-color: #fff;
      img{
        width: 25px;
        height: 25px;
        border-radius: 50%;
      }
      .item{
        padding: 17px 12px 12px 12px;
        border-bottom: 1px solid #FDFCFE;
        span{
          margin: 0 10px;
          color: rgb(185, 185, 185);
          font-size: 14px;
        }
      }
    }
    .box4{
      background-color: #fff;
      .scroll{
        padding: 12px;
        display: flex;
        .card{
          width: 222px;
          background-color: #F8F8F8;
          height: 140px;
          margin-right: 10px;
          .t1{
            position: relative;
            i{
              position: absolute;
              z-index: 1;
              background-color: #0D7096;
              height: 28px;
              width: 30px;
            }
            span{
              display: inline-block;
              width: 80px;
              height: 28px;
              background-color: #EC4E4E;
              transform: skewX(-30deg);
              top: 0;
              left: 8px;
              position: absolute;
              z-index: 2;
            }
            p{
              position: absolute;
              z-index: 99;
              line-height: 28px;
              padding: 0 18px;
              color: #fff;
              font-size: 12px;
              box-sizing: border-box;
            }
          }
          .t2{
            padding: 37.5px 12px 14px 12px;
            font-size: 30px;
            font-weight: 400;
          }
          .t3{
            padding: 0 12px;
            img{
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 12px;
            }
            p{
              font-weight: 600;
            }
            span{
              color: #9B9B9B;
              font-size: 12px;
            }
          }
        }
      }
    }
    .red{
      position: relative;
      &::before{
        content: '';
        position: absolute;
        width: 5px;
        height: 40px;
        left: 0;
        top: 0;
        background-color: #FF726B;
      }
    }
    .lan{
      position: relative;
      &::before{
        content: '';
        position: absolute;
        width: 5px;
        height: 40px;
        left: 0;
        top: 0;
        background-color: #32A5FF;
      }
    }
    .box3{
      background-color: #fff;
      display: flex;
      .title{
        width: 90px;
        font-size: 13px;
        box-shadow: 6px 2px 6px 0px rgba(0,0,0,.06);
        .item{
          color: #999;
          padding: 7px;
          width: 90px;
        }
        .name{
          height: 40px;
          line-height: 40px;
          font-weight: 700;
          box-sizing: border-box;
          padding-left: 9px;
        }
      }
      .scroll{
        width: 285px;
        .content{
          display: flex;
          width: 500px;
          .item{
            width: 50px;
            padding: 7px;
            color: #999;
            text-align: center;
          }
          .score{
            width: 50px;
            height: 40px;
            line-height: 40px;
            font-weight: 600;
            text-align: center;
          }
        }
      }
    }
  }
  .football{
    .title{
      padding: 12px 25px;
      background-color: #fff;
      img{
        width: 25px;
        height: 25px;
        min-width: 25px;
        border-radius: 50%;
      }
      .t1{
        flex: 1;
      }
    }
    .title-box{
      font-size: 17px;
      padding: 8px 16px;
      background-color: #FDFCFE;
      font-weight: 300;
    }
    .gameEvent{
      background-color: #fff;
      display: flex;
      border-top: 1px solid #f0f0f0;
      .left{
        border-right: 1px solid #f0f0f0;
      }
      .card{
        padding: 0 12px;
        flex: 1;
        .item{
          padding: 6px 0;
          p{
            color: rgb(185, 185, 185);
            margin-bottom: 4px;
          }
          .icon{
            flex-wrap: wrap;
            div{
              width: 50%;
              justify-content: flex-start;
            }
          }
        }
        img{
          width: 14px;
          height: 14px;
          margin-right: 7px;
        }
      }
    }
    .ts{
      background-color: #fff;
      padding: 9px;
      text-align: center;
      font-size: 12px;
      color: rgb(222, 222, 222);
      p{
        padding: 2px 0;
      }
    }
  }
  .ice-hockey{
    padding: 12px 16px;
    padding-right: 0;
    background-color: #fff;
    .table{
      position: relative;
      padding-left: 170px;
      color: #000;
      height: 100px;
      background-color: #F5F7FA;
      border: 1px solid #DCDFE6;
      border-bottom: none;
      .left{
        position: absolute;
        left: 0;
        width: 170px;
      }
      .right{
        overflow: auto;
        .item{
          border-left: none !important;
        }
      }
      .link{
        display: flex;
        .title{
          font-size: 13px;
          font-weight: 500;
          color: #8E9196 !important;
        }
        .team-name{
          width: 120px !important;
          box-sizing: border-box;
          padding-left: 6px;
          text-align: left !important;
        }
        .item{
          height: 32px;
          line-height: 32px;
          text-align: center;
          border-right: 1px solid #DCDFE6;
          width: 50px;
          min-width: 50px;
          font-size: 13px;
          // font-weight: 500;
          color: #1D2129;
          border-bottom: 1px solid #DCDFE6;
        }
      }
      .home{
        .team-name{
          background: rgba(38, 161, 255, 0.2) !important;
        }
        .item {
          background: #F3F8FE;
        }
      }
      .away{
        .team-name{
          background: rgba(250, 104, 43, 0.2) !important;
        }
        .item{
           background: #FEF5F5;
        }
      }
    }
    .mvp{
      padding-right: 16px;
      margin-top: 20px;
      .title{
        font-size: 16px;
        font-weight: 500;
        color: #303133;
      }
      .card{
        height: 70px;
        border-radius: 5px;
        padding-left: 8px;
        padding-right: 12px;
        display: flex;
        align-items: center;
        margin-top: 8px;
        img{
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 12px;
          background-color: #333;
        }
        .info{
          flex: 1;
          .name{
            font-size: 14px;
            color: #303133;
          }
          .text{
            font-size: 12px;
            color: #73767A;
          }
          .position{
            font-size: 12px;
            color: #303133;
            margin-top: 2.5px;
          }
        }
        .btn{
          width: 73px;
          height: 26px;
          border-radius: 13px;
          text-align: center;
          line-height: 26px;
          font-size: 12px;
          color: #fff;
          max-width: 73px;
        }
      }
      .home{
        background: #F3F8FE;
        .btn{
          background-color: #4DA1F8;
        }
      }
      .away{
        background: #FEF5F5;
        .btn{
          background-color: #E85F2E;
        }
      }
    }
    .players{
      padding-right: 16px;
      margin-top: 20px;
      .title{
        font-size: 16px;
        font-weight: 500;
        color: #303133;
      }
      .tabs{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 8px;
        .tab{
          width: 160px;
          height: 36px;
          border-radius: 18px;
          background: #F5F7FA;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          font-weight: 500;
        }
        .home{
          background-color: #F5F7FA;
          color: #4DA1F8;
        }
        .away{
          background-color: #F5F7FA;
          color: #E85F2E;
        }
        .home-active{
          background-color: #4DA1F8;
          color: #fff;
        }
        .away-active{
          background-color: #E85F2E;
          color: #fff;
        }
      }
      .players-list{
        margin-top: 13px;
        .player-item{
          display: flex;
          align-items: center;
          border-bottom: 1px solid #E4E7ED;
          padding-top: 10px;
          padding-bottom: 11px;
          img{
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 6px;
          }
          .info{
            flex: 1;
            .name{
              font-size: 14px;
              color: #303133;
            }
            .text{
              color: #73767A;
              font-size: 12px;
              margin-top: 2px;
            }
          }
          .data{
            width: 50px;
            text-align: center;
            color: #303133;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .label{
          .info{
            color: #909399;
          }
          .data{
            color: #909399;
          }
        }
      }
    }
    .kong{
      img{
        width: 120px;
        height: 120px;
      }
      p{
        color: #B9BAB9;
      }
      text-align: center;
      margin-top: 20px;
    }
  }
}
.flex-conter{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overflow-text{
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
